import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetLastWeekPointRankingResponseDataDto } from 'viewup-api/v2';

// 반환 타입을 명시한다 — 이유는 getRankingMonth.ts 주석 참고(`AxiosResponse` 타입 인자 개수
// malformed → skipLibCheck가 가려 사용처가 조용히 `any`로 무너지는 문제).
export const getRankingWeek = async (): Promise<GetLastWeekPointRankingResponseDataDto[]> => {
  const response = await serviceApi.point.getLastWeekPointRanking(withServiceRequestDefaults());

  return response.data.data;
};
